import { render } from "./ChevronDownMiniSVG.vue?vue&type=template&id=74366a82"
const script = {}

import exportComponent from "/Users/gordonwong/Shedd/aerocle-client/aerocle-client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__